import { render, staticRenderFns } from "./indexMany.vue?vue&type=template&id=7a4aa96c"
import script from "./indexMany.vue?vue&type=script&lang=js"
export * from "./indexMany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports